export const OPTIONS_WEB_FEE = [
  {
    value: "PACKAGE",
    name: 'Gói'
  },
  {
    value: "CLICK",
    name: 'Click'
  }
]